<template>
    <b-row id="middlebar_component"
           class="middlebar-component"
           no-gutters>
        <b-col id="header_logo"
               class="header-logo"
               lg="3"
               cols="6">
            <header-logo></header-logo>
        </b-col>
        <b-col id="header_user"
               class="header-user"
               lg="9"
               cols="6">
            <header-user class="desktop-only"></header-user>
            <main-menu-hamburger></main-menu-hamburger>
            <header-options class="desktop-only"></header-options>
        </b-col>
        <b-col id="header_alert"
               class="header-alert"
               cols="12">
            <header-cookie-message cookie="message_1"
                                   message="<p class='color--white'>We would like to hereby inform you that distribution of the FuturoNetwork service within the MLM system, which was suspended in the territory of the European Union, Switzerland and the United States, will be ultimately unavailable in the aforementioned destinations.</p>
            <p class='color--white'>The aforementioned decision is made following the legal regulations effective in these countries.</p>"></header-cookie-message>
        </b-col>
        <b-col id="header_alert"
               class="header-alert"
               cols="12"
               v-if="!termsAccepted">
            <header-alert-bottom></header-alert-bottom>
        </b-col>
    </b-row>
</template>

<script>
    import HeaderCookieMessage from './middlebar/HeaderCookieMessage.vue';
    import HeaderAlertBottom from './middlebar/HeaderAlertBottom.vue';
    import HeaderLogo from './middlebar/HeaderLogo.vue';
    import HeaderOptions from './middlebar/HeaderOptions.vue';
    import HeaderUser from './middlebar/HeaderUser.vue';
    import MainMenuHamburger from './../section/menu/MainMenuHamburger.vue';

    export default {
        components: { HeaderAlertBottom, HeaderLogo, HeaderCookieMessage, HeaderOptions, HeaderUser, MainMenuHamburger },
        computed: {
            termsAccepted () {
                return this.$store.getters.user['terms_of_use_accepted'];
            }
        }
    }
</script>

<style lang="scss">
    .middlebar-component{
        justify-content: space-between;
        margin: 30px 0 45px;

        @media(max-width: 360px){
            margin: 0 0 15px;
        }
    }

    .header-user{
        padding: 11px 0 0;
        text-align: right;
    }
</style>


// WEBPACK FOOTER //
// src/components/layout/partials/header/Middlebar.vue